import React from "react";
import "./LocationMap.css";

const LocationMap = () => {
  return (
    <div className="map-container">
      <iframe
        title="Google Map Location"
        src="https://www.google.com/maps?q=Hungary%202400%20Dunaújváros,%20Apáczai%20Csere%20János%20út%2013&output=embed"
        loading="lazy"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default LocationMap;